import type { OHLCV } from '@shared/types/candle'

import { registerIndicator } from '@/indicators/registry'
import type { IndicatorConfig, IndicatorResult } from '@/types/indicator'
import { IndicatorBase } from '@/types/indicator'

const CONFIG: IndicatorConfig = {
  id: 'sma',
  name: 'Simple Moving Average',
  shortName: 'SMA',
  category: 'trend',
  overlay: true,
  params: [{ key: 'period', label: 'Period', type: 'number', default: 20, min: 1, max: 500 }],
  lines: [{ key: 'sma', label: 'SMA', color: '#2962ff', width: 1 }],
}

class SMA extends IndicatorBase {
  readonly config = CONFIG

  calculate(candles: OHLCV[], params: Record<string, number | string | boolean>): IndicatorResult {
    const period = Math.max(1, Number(params['period']) || 20)
    const values: (number | null)[] = new Array<number | null>(candles.length).fill(null)

    let sum = 0
    for (let i = 0; i < candles.length; i++) {
      sum += candles[i].c
      if (i >= period) sum -= candles[i - period].c
      if (i >= period - 1) values[i] = sum / period
    }

    return { lines: [{ key: 'sma', values }] }
  }
}

registerIndicator(SMA, CONFIG)
